<div class="text-center">
    <h2 style="margin-bottom: 0">{{ titleResource | translate }}</h2>
    <ul class="nav btn-tab-group pt-3">
        <li class="nav-item">
            <a class="nav-link btn-tab active" id="#categories-tab" data-bs-toggle="tab" href="#categories"
                role="tab">{{ 'reservationTags.labels.categories' | translate }}</a>
        </li>
        <li class="nav-item">
            <a class="nav-link btn-tab" id="#tags-tab" data-bs-toggle="tab" href="#tags" role="tab">
                {{ 'reservationTags.labels.tags' | translate }}
            </a>
        </li>
    </ul>
</div>

<div class="tab-content pt-2">
    <!-- Categories -->
    <div class="tab-pane fade show active" id="categories" role="tabpanel">
        <div class="container-sm px-alt-3">
            <div class="search-component py-2">
                <div class="search-container">
                    <input class="ihost-control" [(ngModel)]="searchCategory" name="search" type="search"
                        placeholder="{{ 'reservationTags.placeholders.searchCategory' | translate }}">
                    <button (click)="clearSearch()" class="btn-clear" type="button">&times;</button>
                </div>
                <a class="btn btn-sm btn-main px-2 ms-2" (click)="showAddCategoryModal()">
                    {{ 'common.buttons.addNew' | translate }}
                </a>
            </div>
        </div>

        <div class="container-sm mt-3 pb-5">
            <table class="list-table-item">
                <tbody *ngFor="let item of categories | searchPipe:searchCategory:['name']">
                    <tr>
                        <td>
                            <i class="color-square color-square-sm" [ngStyle]="{ 'background-color': item.color }"></i>
                            {{item.name}}
                        </td>
                        <td class="td-actions w-1p text-nowrap">
                            <app-dotted-dropdown *ngIf="!item.isDietary()" [context]="item" [actions]="categoryActions">
                            </app-dotted-dropdown>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <!-- Tags -->
    <div class="tab-pane fade" id="tags" role="tabpanel">
        <div class="search-component py-2">
            <div class="search-container">
                <input class="ihost-control" [(ngModel)]="searchTag" name="searchTag" type="search"
                    placeholder="{{ 'reservationTags.placeholders.search' | translate }}">
                <button (click)="clearSearchTag()" class="btn-clear" type="button">&times;</button>
            </div>
            <!--<a class="btn btn-sm btn-main px-2 ms-2" (click)="showAddTagModal()">
                {{ 'common.buttons.addNew' | translate }}
            </a>-->
        </div>
        <div class="container-sm mt-3">
            <div *ngFor="let category of categories; let i = index">
                <h3 class="table-left-padding mb-2"
                    style="display: flex; align-items: center; justify-content: space-between;"
                    [ngClass]="{'mt-2': i > 0}">

                    <span>
                        <i class="color-square color-square-sm" style="position: relative; top: 1px"
                            [ngStyle]="{ 'background-color': category.color }"></i>
                        {{ " " + category.name.toUpperCase() }}
                    </span>

                    <button (click)="showAddTagModal(category)" class="btn btn-sm btn-main px-2 ms-2" type="button">{{
                        'common.buttons.addNew' | translate }}</button>
                </h3>
                <table class="list-table-item">
                    <tbody *ngFor="let item of category.tags | searchPipe:searchTag:['title']">
                        <tr>
                            <td>
                                <i class="color-square color-square-sm"
                                    [ngStyle]="{ 'background-color': category.color }"></i>
                                {{item.title}}
                            </td>
                            <td class="td-actions w-1p text-nowrap">
                                <app-dotted-dropdown [context]="[category, item]" [actions]="tagActions">
                                </app-dotted-dropdown>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<app-modal-dialog #categoryModal
    title="{{ (selectedCategory.id == '' ? 'reservationTags.category.create' : 'reservationTags.category.edit') | translate }}"
    modalId="reservation-category-tag-modal" okText="{{ 'reservationTags.category.save' | translate }}"
    [isValid]="isCategoryValid" [errorMessage]="categoryErrorMessage" (onClose)="categoryModalClosed($event)">
    <div class="form-col">
        <app-color-dropdown (modelChange)="categoryColorChanged($event)" [(model)]="selectedCategory.color">
        </app-color-dropdown>

        <input [(ngModel)]="selectedCategory.name" required #name="ngModel" type="text" class="ihost-control w-100 mb-2"
            (ngModelChange)="updateCategoryValid()"
            placeholder="{{ 'reservationTags.placeholders.tagCategory' | translate }}" />

        <input [(ngModel)]="selectedCategory.order" type="number" min="1" step="1" class="ihost-control w-100 mb-2"
            (ngModelChange)="updateCategoryValid()" *ngIf="selectedCategory.id != ''"
            placeholder="{{ 'reservationTags.placeholders.tagCategoryOrder' | translate }}" />
    </div>
</app-modal-dialog>

<app-modal-dialog #deleteCategoryModal title="{{ 'reservationTags.category.delete' | translate }}"
    modalId="delete-category-modal" okText="{{ 'common.buttons.delete' | translate }}"
    (onClose)="deleteCategoryModalClosed($event)">
    <p>{{ 'common.info.delete' | translate }}</p>
</app-modal-dialog>

<app-reservation-tag-modal #tagModal [categories]="categories" [selectedTag]="selectedTag" [tagType]="tagType"
    (onClose)="tagModalClosed($event)"></app-reservation-tag-modal>

<app-modal-dialog #deleteTagModal title="{{ 'reservationTags.tag.delete' | translate }}" modalId="delete-tag-modal"
    okText="{{ 'common.buttons.delete' | translate }}" (onClose)="deleteTagModalClosed($event)">
    <p>{{ 'common.info.delete' | translate }}</p>
</app-modal-dialog>